import { render } from "./ChartDiagram.vue?vue&type=template&id=612a58c7&scoped=true"
import script from "./ChartDiagram.vue?vue&type=script&lang=js"
export * from "./ChartDiagram.vue?vue&type=script&lang=js"

import "./ChartDiagram.vue?vue&type=style&index=0&id=612a58c7&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-612a58c7"]])

export default __exports__